<div *ngIf="!isLoggedIn">
    <div class="topbar" fxLayout="row" fxLayoutAlign="start center">
        <a routerLink="" title="Click here to go to Homepage">
            <img src="./assets/images/header-logo.png" fxShow fxHide.xs alt="UnitedHealthcare StudentResources Logo" />
            <img src="../assets/images/logoMobileUHC.svg" fxHide fxShow.xs
                alt="UnitedHealthcare StudentResources Logo" />
        </a>
        <div fxFlex></div>
    </div>
    <main>
        <div>
            <div class="innerContentWrapper">
                <div class="waiverCard">
                    <div layout="column" class="md-inline-form inputLogin">
                        <div class="serverErrorModal">
                            <div class="serverErrorMessage">
                                <h2>You have been logged out of your account.</h2>
                                <div class="fontDiv">
                                    Please <span class="underlineThis"> <a href="javascript:void(0)"
                                            (click)="loginAgain()" style="color:#ffff">click here </a></span> to login
                                    again
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>